import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpService } from '../../../services/help.service';
import { ExperienceManager } from '../../../managers/experience.manager';
import { NotificationManager } from '../../../managers/notification.manager';
import { BaseComponent } from '../../base.component';
import { Store } from '@ngrx/store';
import { UserConfigsActions } from "@store/app.actions";

@Component({
    selector: 'lex-login-challenge',
    templateUrl: './login-challenge.component.html',
    styleUrls: ['./login-challenge.component.scss'],
    standalone: false
})
export class LoginChallengeComponent extends BaseComponent implements OnInit, OnDestroy {
	public loginForm = this.formBuilder.group({
		code: [null, Validators.required]
	});

	public isLoading: boolean = false;

	constructor(
		private readonly router: Router,
		private readonly formBuilder: UntypedFormBuilder,
		private readonly authenticationService: AuthenticationService,
		private readonly helpService: HelpService,
		private readonly experienceManager: ExperienceManager,
		private readonly notificationManager: NotificationManager,
		private store: Store
	) {
		super();

		this.experienceManager.updateState({
			showTopBar: false
		});
	}

	ngOnDestroy() {
		this.experienceManager.updateState({
			showTopBar: true
		});
	}

	ngOnInit() {
		this.loginForm = this.formBuilder.group({
			code: [null, Validators.required]
		});

		this.helpService.updateHelpLink('logging-in');
	}

	public onSubmit() {
		if (!this.loginForm.valid) return;

		this.isLoading = true;

		this.authenticationService.validateMfaCode(this.loginForm.get('code').value)
			.subscribe({
				next: () => {
					this.store.dispatch(UserConfigsActions.authenticated());
					this.router.navigate(['/'])
				},
				error: () => {
					this.notificationManager.displaySnackBarMessage({
						message: 'An invalid code was provided. Please login and try again.',
						ttl: 10000,
						type: 'error'
					})
					this.isLoading = false
					this.router.navigate(['/identity/login'])
				}
			});
	}
}
